module.exports = __webpack_public_path__ + "img/hidden-field-logo-icon.b006b92e.svg";